import { Component, OnInit, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, Subject } from 'rxjs';
import { AuthJwtService } from '../../../services/auth-jwt.service';
import { LanguageService } from '../../../services/language.service';
import { MenuDTO } from '../../../models/menu-dto';
import { SharedService } from '../../../services/shared.service';
import { UserService } from '../../../services/user.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {

  menu: MenuDTO;

  isNavbarPrimaryCollapsed = true;
  isNavbarSecondaryCollapsed = true;
  isAuthenticated = false;

  @ViewChild('navBarContainer') navBarContainer!: ElementRef;
  onNavbarCollapse$ = new Subject<void>();

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isNavbarPrimaryCollapsed && this.isNavbarSecondaryCollapsed) {
      return;
    }
    if (this.navBarContainer && !this.navBarContainer.nativeElement.contains(event.target)) {
      this.isNavbarPrimaryCollapsed = true;
      this.isNavbarSecondaryCollapsed = true;
      this.onNavbarCollapse$.next();
    }
  }

  constructor(
    private router: Router,
    private authJwtService: AuthJwtService,
    private sharedService: SharedService,
    public languageService: LanguageService) {
  }


  ngOnInit() {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          if(!this.isNavbarPrimaryCollapsed) {
            this.toggleNavbars();
          }
        });

    this.isAuthenticated = this.authJwtService.isAuthenticated();
    if (this.isAuthenticated) {
      this.getMenu();
    }
  }

  logout() {
    this.authJwtService.logout();
    this.router.navigate(['/login']);
  }

  getMenu() {
    this.sharedService.getMenu().subscribe(resp => {
      this.menu = resp;
    });
  }

  toggleNavbars(primary: boolean = true, secondary: boolean = true): void {
    if (primary) {
      this.isNavbarPrimaryCollapsed = !this.isNavbarPrimaryCollapsed;
    }
    if (secondary) {
      this.isNavbarSecondaryCollapsed = !this.isNavbarSecondaryCollapsed;
    }
    this.onNavbarCollapse$.next();

    console.log('toggleNavbars');

    const allParents = document.querySelectorAll('.second-navbar-collapse [aria-expanded]');

    allParents.forEach(parent => {
      const parentLi = parent.closest('li');
      if (!parentLi) return;

      console.log(parentLi);

      const targetUl = parentLi.querySelector('ul');
      if (!targetUl) return;

      console.log(targetUl);

      const hasActiveChild = targetUl.querySelector('.nav-link.active');
      const firstLink = parentLi.querySelector(':scope > a');

      if (hasActiveChild) {
        firstLink.classList.add('active');
      } else {
        firstLink.classList.remove('active');
      }
    });
  }
}
